export { default as useLogrocketTargetedRecording } from './use-logrocket-targeted-recording';
